var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707129f2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infoclick/ToggleButton.vue
// module id = lPmp
// module chunks = 1